/**
 * Bundle Picker – One-time purchase container with pack pills & type dropdowns.
 * Replaces Recurpay's native onetime container, sits alongside Recurpay's
 * subscription widget. Replicates VariantSelects integration contract.
 */
if (!customElements.get('bundle-picker')) {
  class BundlePicker extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onSelectionChange.bind(this));
    }

    connectedCallback() {
      this.variantData = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );
      this.mixedLabel = this.dataset.mixedLabel || 'One of each';

      // Bind header click to select one-time purchase
      var header = this.querySelector('.bundle-picker__purchase-header');
      if (header) {
        header.addEventListener('click', this.onPurchaseHeaderClick.bind(this));
      }

      this.updateActivePill();
      this.resolveAndUpdate(false);

      // Fix: Set variant input on initial load so Add to Cart works immediately
      if (this.currentVariant) {
        this.updateVariantInput();
      }

      this.setupRecurpaySync();
      this.setupFormIntercept();
      this.positionNearRecurpay();
    }

    /* ------------------------------------------------------------------ */
    /*  Recurpay sync — simple & robust                                    */
    /* ------------------------------------------------------------------ */
    setupRecurpaySync() {
      var self = this;

      // Use jQuery to listen — Recurpay triggers changes via jQuery, not native events
      var bindListener = function () {
        if (typeof jQuery === 'undefined') return false;
        jQuery(document).on('change', '[name="recurpay__group_main"]', function () {
          if (jQuery(this).val() === 'subscription') {
            self.deactivateOnetime();
          } else {
            self.activateOnetime();
          }
        });
        return true;
      };

      // Vanilla JS fallback
      document.addEventListener('change', function (e) {
        if (e.target.name === 'recurpay__group_main') {
          if (e.target.value === 'subscription') {
            self.deactivateOnetime();
          } else {
            self.activateOnetime();
          }
        }
      });

      // Click listener on Recurpay labels as backup
      document.addEventListener('click', function (e) {
        var label = e.target.closest('.recurpay__group_label');
        if (!label) return;
        var container = label.closest('.recurpay__widget_container');
        if (!container) return;
        var type = container.getAttribute('data-type');
        if (type === 'subscription-purchase') {
          self.deactivateOnetime();
        } else if (type === 'onetime-purchase') {
          self.activateOnetime();
        }
      });

      // jQuery might not be loaded yet — retry until available
      if (!bindListener()) {
        var jqCheck = setInterval(function () {
          if (bindListener()) clearInterval(jqCheck);
        }, 200);
        setTimeout(function () { clearInterval(jqCheck); }, 10000);
      }

      // Poll for initial Recurpay state (handles async load + subscriptionFirst)
      var pollCount = 0;
      var pollInterval = setInterval(function () {
        pollCount++;
        var subRadio = document.querySelector(
          'input[name="recurpay__group_main"][value="subscription"]:checked'
        );
        var onetimeRadio = document.querySelector(
          'input[name="recurpay__group_main"][value="one-time"]:checked'
        );

        if (subRadio) {
          self.deactivateOnetime();
          clearInterval(pollInterval);
        } else if (onetimeRadio) {
          self.activateOnetime();
          clearInterval(pollInterval);
        }

        if (pollCount > 30) clearInterval(pollInterval);
      }, 300);
    }

    /* ------------------------------------------------------------------ */
    /*  Form intercept — strip selling plan on one-time purchase            */
    /* ------------------------------------------------------------------ */
    setupFormIntercept() {
      var self = this;
      var sectionId = this.dataset.section;
      var productForm = document.getElementById('product-form-' + sectionId);
      if (!productForm) return;

      productForm.addEventListener('submit', function (e) {
        var isOnetimeActive = self.isOnetimeSelected();
        if (!isOnetimeActive) return;

        // Remove any selling_plan input Recurpay may have injected
        var sellingPlanInputs = productForm.querySelectorAll(
          'input[name="selling_plan"], select[name="selling_plan"]'
        );
        sellingPlanInputs.forEach(function (input) {
          input.disabled = true;
        });

        // Also remove from Recurpay's hidden form if it exists
        var recurpayForms = document.querySelectorAll('.recurpay__form, form[data-recurpay]');
        recurpayForms.forEach(function (form) {
          var sp = form.querySelector('[name="selling_plan"]');
          if (sp) sp.disabled = true;
        });
      });
    }

    isOnetimeSelected() {
      var option = this.querySelector('.bundle-picker__purchase-option');
      return option && option.classList.contains('bundle-picker__purchase-option--active');
    }

    /* ------------------------------------------------------------------ */
    /*  Position near Recurpay widget                                      */
    /* ------------------------------------------------------------------ */
    positionNearRecurpay() {
      var self = this;

      var widget = document.querySelector('.recurpay-pdp-widget');
      if (widget) {
        widget.parentNode.insertBefore(self, widget);
        self.toggleSubscriptionVisibility(self.getSelectedPack());
        return;
      }

      var observer = new MutationObserver(function () {
        var widget = document.querySelector('.recurpay-pdp-widget');
        if (widget) {
          observer.disconnect();
          widget.parentNode.insertBefore(self, widget);
          self.toggleSubscriptionVisibility(self.getSelectedPack());
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 10000);
    }

    activateOnetime() {
      var option = this.querySelector('.bundle-picker__purchase-option');
      if (option) option.classList.add('bundle-picker__purchase-option--active');

      // Remove Recurpay's selected border from the subscription container
      var subContainer = document.querySelector(
        '.recurpay__widget_container[data-type="subscription-purchase"]'
      );
      if (subContainer) subContainer.classList.remove('recurpay__widget_container--selected');

      // Show Add to Cart, hide Recurpay's subscribe button
      var sectionId = this.dataset.section;
      var productForm = document.getElementById('product-form-' + sectionId);
      if (productForm) {
        var addButton = productForm.querySelector('[name="add"]');
        if (addButton) addButton.classList.remove('recurpay-hide');
        var buyNowButton = productForm.querySelector('.shopify-payment-button');
        if (buyNowButton) buyNowButton.classList.remove('recurpay-hide');

        // Disable selling_plan so it won't be submitted with the form
        productForm.querySelectorAll('[name="selling_plan"]').forEach(function (input) {
          input.disabled = true;
        });
      }
      var recurpayAction = document.querySelector('.recurpay__action');
      if (recurpayAction) recurpayAction.classList.add('recurpay-hide');
    }

    deactivateOnetime() {
      var option = this.querySelector('.bundle-picker__purchase-option');
      if (option) option.classList.remove('bundle-picker__purchase-option--active');

      // Restore Recurpay's selected border on the subscription container
      var subContainer = document.querySelector(
        '.recurpay__widget_container[data-type="subscription-purchase"]'
      );
      if (subContainer) subContainer.classList.add('recurpay__widget_container--selected');

      // Hide Add to Cart, show Recurpay's subscribe button
      var sectionId = this.dataset.section;
      var productForm = document.getElementById('product-form-' + sectionId);
      if (productForm) {
        var addButton = productForm.querySelector('[name="add"]');
        if (addButton) addButton.classList.add('recurpay-hide');
        var buyNowButton = productForm.querySelector('.shopify-payment-button');
        if (buyNowButton) buyNowButton.classList.add('recurpay-hide');

        // Re-enable selling_plan for subscription mode
        productForm.querySelectorAll('[name="selling_plan"]').forEach(function (input) {
          input.disabled = false;
        });
      }
      var recurpayAction = document.querySelector('.recurpay__action');
      if (recurpayAction) recurpayAction.classList.remove('recurpay-hide');
    }

    onPurchaseHeaderClick() {
      // Activate our onetime container
      this.activateOnetime();

      // Tell Recurpay to switch to one-time
      var onetimeRadio = document.querySelector(
        'input[name="recurpay__group_main"][value="one-time"]'
      );
      if (onetimeRadio && !onetimeRadio.checked) {
        onetimeRadio.checked = true;
        if (typeof jQuery !== 'undefined') {
          jQuery(onetimeRadio).change();
        } else {
          onetimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // Resolve variant and update the Add to Cart button
      this.resolveAndUpdate(true);
    }

    /* ------------------------------------------------------------------ */
    /*  Main change handler                                                */
    /* ------------------------------------------------------------------ */
    onSelectionChange(event) {
      var target = event.target;

      // Ignore Recurpay radio changes
      if (target.name === 'recurpay__group_main') return;

      if (target.name === 'bundle-pack') {
        this.updateActivePill();
      }

      // Auto-select one-time purchase if not already in that mode
      if (!this.isOnetimeSelected()) {
        this.onPurchaseHeaderClick();
      } else {
        // Just resolve variant if we are already in onetime mode
        this.resolveAndUpdate(true);
      }
    }

    /* ------------------------------------------------------------------ */
    /*  Pill & type-container UI                                           */
    /* ------------------------------------------------------------------ */
    updateActivePill() {
      var selectedPack = this.getSelectedPack();

      this.querySelectorAll('.bundle-picker__pill').forEach(function (pill) {
        var input = pill.querySelector('input');
        if (input && input.value === selectedPack) {
          pill.classList.add('is-active');
        } else {
          pill.classList.remove('is-active');
        }
      });

      this.querySelectorAll('[data-pack-types]').forEach(function (container) {
        if (container.dataset.packTypes === selectedPack) {
          container.classList.add('is-active');
        } else {
          container.classList.remove('is-active');
        }
      });

      // Hide subscription for 2-Pack, show for 1-Pack
      this.toggleSubscriptionVisibility(selectedPack);
    }

    toggleSubscriptionVisibility(selectedPack) {
      var is1Pack = selectedPack === '1-Pack';
      var recurpayWidget = document.querySelector('.recurpay-pdp-widget');
      if (recurpayWidget) {
        recurpayWidget.style.display = is1Pack ? '' : 'none';
      }

      // If switching to 2-Pack while subscription is active, force one-time
      if (!is1Pack && !this.isOnetimeSelected()) {
        this.onPurchaseHeaderClick();
      }
    }

    /* ------------------------------------------------------------------ */
    /*  Selection readers                                                   */
    /* ------------------------------------------------------------------ */
    getSelectedPack() {
      var checked = this.querySelector('input[name="bundle-pack"]:checked');
      return checked ? checked.value : '';
    }

    getSelectedTypes() {
      var activeTypes = this.querySelector('[data-pack-types].is-active');
      if (!activeTypes) return [];
      var selects = activeTypes.querySelectorAll('.bundle-picker__select');
      var values = [];
      selects.forEach(function (sel) {
        values.push(sel.value);
      });
      return values;
    }

    /* ------------------------------------------------------------------ */
    /*  Variant resolution                                                 */
    /* ------------------------------------------------------------------ */
    resolveVariant() {
      var pack = this.getSelectedPack();
      var types = this.getSelectedTypes();

      if (!pack || types.length === 0) return null;

      if (types.length === 1) {
        return this.variantData.find(function (v) {
          return v.option1 === pack && v.option2 === types[0];
        }) || null;
      }

      var allSame = types.every(function (t) {
        return t === types[0];
      });

      if (allSame) {
        return this.variantData.find(function (v) {
          return v.option1 === pack && v.option2 === types[0];
        }) || null;
      } else {
        var mixedLabel = this.mixedLabel.toLowerCase();
        return this.variantData.find(function (v) {
          return v.option1 === pack && v.option2.toLowerCase() === mixedLabel;
        }) || null;
      }
    }

    resolveAndUpdate(userInitiated) {
      this.currentVariant = this.resolveVariant();

      if (userInitiated) {
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
      }

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        // Update displayed price in our onetime header
        this.updateOnetimePrice();

        if (userInitiated) {
          this.updateMedia();
          this.updateURL();
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
        } else {
          // If NOT user initiated (e.g. initial load), ensure button is correctly enabled/disabled
          // but don't force a text change unless it was unavailable before.
          this.toggleAddButton(false, '', false);
        }
      }
    }

    /* ------------------------------------------------------------------ */
    /*  Onetime price display                                              */
    /* ------------------------------------------------------------------ */
    updateOnetimePrice() {
      if (!this.currentVariant) return;
      var priceEl = this.querySelector('[data-onetime-price]');
      if (priceEl) {
        priceEl.textContent = this.formatMoney(this.currentVariant.price);
      }
    }

    formatMoney(cents) {
      var amount = cents / 100;
      return (
        '\u00a3' + (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2))
      );
    }

    /* ------------------------------------------------------------------ */
    /*  Integration methods (VariantSelects contract)                       */
    /* ------------------------------------------------------------------ */
    updateVariantInput() {
      var self = this;
      var sectionId = this.dataset.section;
      var productForms = document.querySelectorAll(
        '#product-form-' + sectionId +
        ', #product-form-installment-' + sectionId
      );
      productForms.forEach(function (productForm) {
        var input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = self.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState(
        {},
        '',
        this.dataset.url + '?variant=' + this.currentVariant.id
      );
    }

    updateShareUrl() {
      var shareButton = document.getElementById(
        'Share-' + this.dataset.section
      );
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(
        window.shopUrl + this.dataset.url + '?variant=' + this.currentVariant.id
      );
    }

    updateMedia() {
      if (!this.currentVariant || !this.currentVariant.featured_media) return;

      var sectionId = this.dataset.section;
      var mediaId = this.currentVariant.featured_media.id;

      var mediaGalleries = document.querySelectorAll(
        '[id^="MediaGallery-' + sectionId + '"]'
      );
      mediaGalleries.forEach(function (gallery) {
        gallery.setActiveMedia(sectionId + '-' + mediaId, true);
      });

      var modalContent = document.querySelector(
        '#ProductModal-' + sectionId + ' .product-media-modal__content'
      );
      if (!modalContent) return;
      var newMediaModal = modalContent.querySelector(
        '[data-media-id="' + mediaId + '"]'
      );
      if (newMediaModal) modalContent.prepend(newMediaModal);
    }

    updatePickupAvailability() {
      var pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      var section = this.closest('section');
      if (!section) return;
      var productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      var self = this;
      var requestedVariantId = this.currentVariant.id;
      var sectionId =
        this.dataset.originalSection || this.dataset.section;

      fetch(
        this.dataset.url +
          '?variant=' + requestedVariantId +
          '&section_id=' + sectionId
      )
        .then(function (response) { return response.text(); })
        .then(function (responseText) {
          if (self.currentVariant.id !== requestedVariantId) return;

          var html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );

          var priceDestination = document.getElementById(
            'price-' + self.dataset.section
          );
          var priceSource = html.getElementById('price-' + sectionId);
          if (priceSource && priceDestination)
            priceDestination.innerHTML = priceSource.innerHTML;

          var skuDestination = document.getElementById(
            'Sku-' + self.dataset.section
          );
          var skuSource = html.getElementById('Sku-' + sectionId);
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle(
              'visibility-hidden',
              skuSource.classList.contains('visibility-hidden')
            );
          }

          var inventoryDestination = document.getElementById(
            'Inventory-' + self.dataset.section
          );
          var inventorySource = html.getElementById(
            'Inventory-' + sectionId
          );
          if (inventorySource && inventoryDestination)
            inventoryDestination.innerHTML = inventorySource.innerHTML;

          var price = document.getElementById(
            'price-' + self.dataset.section
          );
          if (price) price.classList.remove('visibility-hidden');

          if (inventoryDestination)
            inventoryDestination.classList.toggle(
              'visibility-hidden',
              inventorySource.innerText === ''
            );

          var addButtonUpdated = html.getElementById(
            'ProductSubmitButton-' + sectionId
          );
          self.toggleAddButton(
            addButtonUpdated
              ? addButtonUpdated.hasAttribute('disabled')
              : true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: sectionId,
              html: html,
              variant: self.currentVariant,
            },
          });
        });
    }

    toggleAddButton(disable, text, modifyClass) {
      if (disable === undefined) disable = true;
      if (modifyClass === undefined) modifyClass = true;

      var productForm = document.getElementById(
        'product-form-' + this.dataset.section
      );
      if (!productForm) return;
      var addButton = productForm.querySelector('[name="add"]');
      var addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    setUnavailable() {
      var formEl = document.getElementById(
        'product-form-' + this.dataset.section
      );
      if (!formEl) return;
      var addButton = formEl.querySelector('[name="add"]');
      var addButtonText = formEl.querySelector('[name="add"] > span');
      var price = document.getElementById(
        'price-' + this.dataset.section
      );
      var inventory = document.getElementById(
        'Inventory-' + this.dataset.section
      );
      var sku = document.getElementById('Sku-' + this.dataset.section);

      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
      if (inventory) inventory.classList.add('visibility-hidden');
      if (sku) sku.classList.add('visibility-hidden');
    }
  }

  customElements.define('bundle-picker', BundlePicker);
}
